<template>
<kt-row>
    <kt-col xs="12" class="mb-5" v-if="form_data.profile_image">
        <img :src="form_data.profile_image" style="max-width:150px; max-height:150px" class="d-block m-auto">
    </kt-col>
    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="fa_full_name">
                {{ $t('label.first_and_last_name') }}
            </kt-form-label>
            <kt-form-control
                id="fa_full_name"
                name="fa_full_name"
                disabled
                :value="form_data.full_name"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>

    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="fa_gateway_name">
                {{ $t('label.selected_gateway_title') }}
            </kt-form-label>
            <kt-form-control
                id="fa_gateway_name"
                name="fa_gateway_name"
                disabled
                :value="form_data.fa_gateway_name"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>

    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="show_phone_number-div">
                {{ $t('label.phone_number') }}
            </kt-form-label>
            <div class="custom-control custom-checkbox" id="show_phone_number-div">
                <input
                        type="checkbox"
                        class="custom-control-input"
                        id="show_phone_number"
                        disabled
                        name="show_phone_number"
                        v-model="form_data.show_phone_number"
                >
                <label class="custom-control-label" for="show_phone_number">
                    {{ $t('label.show_phone_number') }}
                </label>
            </div>
        </kt-form-group>
    </kt-col>

    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="description">
                {{ $t('label.description') }}
            </kt-form-label>
            <Textarea
                    class="form-control no-resize"
                    rows="9"
                    disabled
                    id="description"
                    name="description"
                    v-model="form_data.description"
            >
                        </Textarea>
        </kt-form-group>
    </kt-col>
    <kt-col lg="12" md="12" xs="12" v-if="form_data.user_name !== null">
        <form>
            <div class="input-group mb-4 mt-4 ">
                <label class="input-group">
                    {{ $t('label.pardakhtShakhsiLink') }}
                </label>
                <div class="input-group-prepend">
                            <span class="input-group-text">
                                <i class="fa fa-copy" style="font-size:24px; cursor:pointer" title="copy" @click="copy"></i>
                            </span>
                </div>
                <input class="form-control" type="text" dir="ltr"  name="register_link" id="register_link" v-model="pardakhtShakhsiLink" disabled>
            </div>
        </form>
    </kt-col>
</kt-row>
</template>

<script>


import Textarea from "../../../components/elements/form/textarea";
import $ from "jquery";

export default {
    components: {Textarea},
    props: {
        form_data: {
            default() {
                return {}
            },
            required: true,
        }
    },
    data() {
        return {
            pardakhtShakhsiLink: window.location.origin + '/d/@' + this.form_data.user_name,
        }
    },
    computed: {

    },
    methods: {
        copy() {
            let copiedLink = $('#register_link')
            copiedLink.removeAttr('disabled');
            copiedLink.select()
            document.execCommand("copy")
            copiedLink.attr('disabled','disabled');
        },
    }
}
</script>

<style scoped>
    .no-resize {
        resize: none;
    }
</style>